import { render, staticRenderFns } from "./package-custom-carrier-label.vue?vue&type=template&id=89ec72b8&scoped=true"
import script from "./package-custom-carrier-label.vue?vue&type=script&setup=true&lang=js"
export * from "./package-custom-carrier-label.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ec72b8",
  null
  
)

export default component.exports